



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class OverlayProsesBerkas extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: String, default: "Menyiapkan berkas laporan" })
  readonly judul!: string;

  detik = 0;
  pewaktu: number | null = null;

  @Watch("value", { immediate: true })
  onValue(aktif: boolean): void {
    this.hentikan();

    if (!aktif) return;

    const mulai = Date.now();
    this.detik = 0;
    this.pewaktu = window.setInterval(() => {
      this.detik = Math.floor((Date.now() - mulai) / 1000);
    }, 1000);
  }

  beforeDestroy(): void {
    this.hentikan();
  }

  hentikan(): void {
    if (this.pewaktu !== null) {
      window.clearInterval(this.pewaktu);
      this.pewaktu = null;
    }
  }
}
